import { useAuth } from 'src/components/AuthProvider/AuthProvider';

export const useCanAccessParentAdminFlows = (): boolean => {
  const {
    enterpriseData: { isParentAdminUser, isInternalAdminUser },
  } = useAuth();

  // We use a user's claims to determine if they have access to certain pages/flows
  return isInternalAdminUser || isParentAdminUser;
};
